// Mock data for Top-Notch Tile website

export const businessInfo = {
  name: "Top Notch Tile LLC",
  tagline: "Crafting Beautiful Spaces, One Tile at a Time",
  address: "Osterville, MA",
  email: "contactus@topnotchtile.com",
  phone: "+1 (857) 498-7357",
  serviceArea: "Cape Cod & South Shore, MA"
};

export const stats = [
  { number: "2,500+", label: "Bathrooms Completed" },
  { number: "15+", label: "Years Experience" },
  { number: "1,200+", label: "Happy Customers" },
  { number: "100%", label: "Satisfaction Rate" }
];

export const services = [
  {
    id: 1,
    title: "Bathroom Tile",
    description: "Transform your bathroom into a stunning retreat with custom tile work. From floor to ceiling, showers to tub surrounds.",
    image: "https://images.unsplash.com/photo-1558211583-ecfebb03748b?w=800&q=80"
  },
  {
    id: 2,
    title: "Kitchen Backsplash",
    description: "Elevate your kitchen with beautiful backsplash designs. Subway tiles, mosaics, and custom patterns available.",
    image: "https://images.unsplash.com/photo-1564540586988-aa4e53c3d799?w=800&q=80"
  },
  {
    id: 3,
    title: "Floor Tiling",
    description: "Durable and elegant floor tile installation for any room. Porcelain, ceramic, natural stone, and more.",
    image: "https://images.unsplash.com/photo-1585412727362-3abb5d23bc31?w=800&q=80"
  },
  {
    id: 4,
    title: "Custom Designs",
    description: "Unique patterns and artistic installations. Bring your vision to life with our custom tile design services.",
    image: "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=800&q=80"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    location: "Osterville, MA",
    rating: 5,
    text: "Top-Notch Tile completely transformed our master bathroom. The attention to detail was incredible, and they finished on time and within budget. Highly recommend!",
    project: "Master Bathroom Renovation"
  },
  {
    id: 2,
    name: "Michael Chen",
    location: "Hyannis, MA",
    rating: 5,
    text: "We hired them for our kitchen backsplash and couldn't be happier. Professional, clean, and the craftsmanship is outstanding. Our kitchen looks amazing!",
    project: "Kitchen Backsplash"
  },
  {
    id: 3,
    name: "Jennifer & David Ross",
    location: "Barnstable, MA",
    rating: 5,
    text: "Third project with Top-Notch Tile - they've done two bathrooms and our entryway floors. Consistent quality every time. They're our go-to tile contractors.",
    project: "Multiple Rooms"
  },
  {
    id: 4,
    name: "Robert Thompson",
    location: "Chatham, MA",
    rating: 5,
    text: "The team was professional from start to finish. They helped us choose the perfect tiles and the installation was flawless. Worth every penny!",
    project: "Guest Bathroom"
  }
];

export const galleryImages = [
  "https://images.unsplash.com/photo-1558211583-ecfebb03748b?w=600&q=80",
  "https://images.unsplash.com/photo-1564540586988-aa4e53c3d799?w=600&q=80",
  "https://images.unsplash.com/photo-1585412727362-3abb5d23bc31?w=600&q=80",
  "https://images.unsplash.com/photo-1703868669362-562283170216?w=600&q=80",
  "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?w=600&q=80"
];
